import React from 'react';
import { HeartCrackIcon, DollarSignIcon, HelpCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const stats = [{
    icon: HeartCrackIcon,
    title: 'Diagnósticos sin apoyo',
    description: 'Familias enfrentan diagnósticos complejos sin recursos ni orientación'
  }, {
    icon: DollarSignIcon,
    title: 'Costos inaccesibles',
    description: 'Terapias y tratamientos biomédicos fuera del alcance económico'
  }, {
    icon: HelpCircleIcon,
    title: 'Decisiones aisladas',
    description: 'Padres toman decisiones críticas sin información integrada'
  }];
  return <section id="nosotros" className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-166">
      <div className="max-w-6xl mx-auto" data-id="element-167">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-168">
          <div data-id="element-169">
            <h2 className="text-3xl sm:text-4xl font-bold text-dark mb-4" data-id="element-170">
              El Problema
            </h2>
            <p className="text-lg text-gray-600" data-id="element-171">
              Hoy, muchas familias enfrentan diagnósticos, terapias, costos
              médicos y decisiones diarias sin recursos financieros
            </p>
          </div>
          <div data-id="element-172">
            <img src="https://cdn.magicpatterns.com/uploads/eBEDv17LBRGEQhmeBueWEQ/heylloyd-image-1782595943394.png" alt="Madre preocupada con su hijo" className="w-full h-80 object-cover rounded-2xl shadow-lg" data-id="element-173" />
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-174">
          {stats.map((stat, index) => <div key={index} className="bg-gray-50 rounded-2xl p-8 text-center shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" data-id="element-175">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full mb-6" data-id="element-176">
                <stat.icon className="w-8 h-8 text-accent" data-id="element-177" />
              </div>
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-178">{stat.title}</h3>
              <p className="text-gray-600" data-id="element-179">{stat.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}